import React from "react";
import { Link } from "react-router-dom";
import "./laviens-logo.component.styles.scss";
import { useLang } from "../../../lib/i18n";

interface LaviensLogoProps {
  onClick?: () => void;
}

const LaviensLogo: React.FC<LaviensLogoProps> = ({ onClick }) => {
  const { lang, lp } = useLang();
  const isEn = lang === "en";
  return (
    <Link
      to={lp("/")}
      className="lvs-logo"
      title={
        isEn
          ? "Laviens — Wellness Studio, Florence"
          : "Laviens — Studio Olistico, Firenze"
      }
      aria-label={isEn ? "Laviens — homepage" : "Laviens — homepage"}
      onClick={onClick}
    >
      <span className="lvs-logo__mark" aria-hidden="true">
        <img
          src="/brand/mark.png"
          alt=""
          width={34}
          height={34}
          className="lvs-logo__img"
        />
      </span>
      <span className="lvs-logo__word">Laviens</span>
    </Link>
  );
};

export default LaviensLogo;
